import { render } from "./ForgotPin.vue?vue&type=template&id=26501efe&scoped=true"
import script from "./ForgotPin.vue?vue&type=script&lang=js"
export * from "./ForgotPin.vue?vue&type=script&lang=js"

import "./ForgotPin.vue?vue&type=style&index=0&id=26501efe&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26501efe"]])

export default __exports__